export const productCategories = [
  {
    name: "Plasticizers & Additives",
    icon: "🔬",
    products: [
      {
        name: "Chlorinated Paraffin Wax 52%",
        description: "High chlorine content plasticizer for PVC applications",
        uses: "PVC cables, flooring, hoses, and flexible tubing",
        packaging: "200kg drums, 25kg bags, bulk tankers",
      },
      {
        name: "Chlorinated Paraffin Wax 45%",
        description: "Medium chlorine content plasticizer and flame retardant",
        uses: "Rubber, paints, sealants, and adhesives",
        packaging: "200kg drums, 25kg bags, bulk tankers",
      },
      {
        name: "DOP (Dioctyl Phthalate)",
        description: "Primary plasticizer for PVC with excellent compatibility",
        uses: "PVC films, sheets, cables, and automotive parts",
        packaging: "200kg drums, IBC tanks, bulk tankers",
      },
      {
        name: "DOTP (Dioctyl Terephthalate)",
        description:
          "Non-phthalate plasticizer, eco-friendly alternative to DOP",
        uses: "Food-grade PVC, medical devices, children's toys",
        packaging: "200kg drums, IBC tanks, bulk tankers",
      },
      {
        name: "Dioctyl Maleate (DOM)",
        description:
          "Vinyl plasticizer with superior low-temperature properties",
        uses: "PVC films, coatings, and synthetic rubber",
        packaging: "200kg drums, IBC tanks",
      },
      {
        name: "Calcium Carbonate",
        description: "Mineral filler and pigment for plastics and coatings",
        uses: "PVC pipes, profiles, paints, paper, and adhesives",
        packaging: "25kg bags, 50kg bags, bulk bags",
      },
    ],
  },
  {
    name: "Water Treatment Chemicals",
    icon: "💧",
    products: [
      {
        name: "Sulphuric Acid 98%",
        description:
          "Concentrated mineral acid for pH adjustment and treatment",
        uses: "pH control, metal processing, industrial cleaning",
        packaging: "30kg carboys, 50kg drums, bulk tankers",
      },
      {
        name: "Poly Aluminium Chloride (PAC)",
        description: "High-efficiency coagulant for water purification",
        uses: "Drinking water treatment, wastewater treatment, industrial effluent",
        packaging: "25kg bags, 50kg drums, bulk bags",
      },
      {
        name: "Sodium Hypochlorite",
        description: "Liquid chlorine disinfectant and bleaching agent",
        uses: "Water disinfection, bleaching, sanitation",
        packaging: "30kg carboys, 50kg drums, bulk tankers",
      },
      {
        name: "TCCA 90% (Trichloroisocyanuric Acid)",
        description: "Stabilized chlorine tablets for water disinfection",
        uses: "Swimming pools, drinking water, industrial cooling towers",
        packaging: "50kg drums, 25kg pails",
      },
      {
        name: "Industrial Salt",
        description: "High-purity sodium chloride for water softening",
        uses: "Water softening, brine preparation, de-icing",
        packaging: "25kg bags, 50kg bags, bulk bags",
      },
      {
        name: "Chlorine Tablets",
        description: "Slow-dissolving chlorine for continuous disinfection",
        uses: "Water treatment, swimming pools, sanitation",
        packaging: "1kg, 5kg, 25kg containers",
      },
      {
        name: "Caustic Soda Flakes",
        description: "Sodium hydroxide flakes for pH adjustment and cleaning",
        uses: "pH control, pulp & paper, soap manufacturing, water treatment",
        packaging: "25kg bags, 50kg bags",
      },
      {
        name: "Hydrochloric Acid",
        description: "Strong mineral acid for industrial applications",
        uses: "pH adjustment, pickling, metal cleaning, chemical synthesis",
        packaging: "30kg carboys, 50kg drums, bulk tankers",
      },
    ],
  },
  {
    name: "Chemical Intermediates",
    icon: "⚗️",
    products: [
      {
        name: "Mono Chloro Benzene (MCB)",
        description: "Aromatic chlorinated solvent and chemical intermediate",
        uses: "Nitrochlorobenzene production, solvent, degreasing agent",
        packaging: "200kg drums, IBC tanks, bulk tankers",
      },
      {
        name: "Ortho Dichloro Benzene (ODCB)",
        description: "Chlorinated aromatic compound for chemical synthesis",
        uses: "Agrochemicals, dyes, pharmaceuticals, deodorants",
        packaging: "200kg drums, IBC tanks",
      },
      {
        name: "Para Dichloro Benzene (PDCB)",
        description: "White crystalline solid for pest control and synthesis",
        uses: "Moth repellent, deodorant, dye intermediate",
        packaging: "25kg bags, 50kg drums",
      },
      {
        name: "Benzyl Chloride",
        description: "Reactive chlorinated intermediate for synthesis",
        uses: "Benzyl compounds, dyes, pharmaceuticals, resins",
        packaging: "200kg drums, IBC tanks",
      },
      {
        name: "Dimethyl Sulphate",
        description: "Methylating agent for organic synthesis",
        uses: "Dye manufacturing, pharmaceuticals, agrochemicals",
        packaging: "200kg drums, bulk tankers",
      },
    ],
  },
  {
    name: "Petrochemicals & Solvents",
    icon: "🛢️",
    products: [
      {
        name: "Acetone",
        description: "Versatile organic solvent for multiple applications",
        uses: "Paint thinner, nail polish remover, adhesive solvent, cleaning",
        packaging: "150kg drums, IBC tanks, bulk tankers",
      },
      {
        name: "Methanol",
        description: "Light volatile alcohol solvent and fuel additive",
        uses: "Fuel blending, formaldehyde production, solvent",
        packaging: "150kg drums, IBC tanks, bulk tankers",
      },
      {
        name: "Xylene",
        description: "Aromatic hydrocarbon solvent mixture",
        uses: "Paint thinner, printing, rubber, leather industries",
        packaging: "150kg drums, IBC tanks, bulk tankers",
      },
      {
        name: "Toluene",
        description: "Aromatic solvent and octane booster",
        uses: "Paint thinner, adhesives, fuel additive, chemical synthesis",
        packaging: "150kg drums, IBC tanks, bulk tankers",
      },
      {
        name: "Ethylene Dichloride (EDC)",
        description: "Chlorinated solvent and PVC precursor",
        uses: "PVC production, metal degreasing, extraction solvent",
        packaging: "200kg drums, IBC tanks, bulk tankers",
      },
      {
        name: "Cyclohexane",
        description: "Alicyclic hydrocarbon solvent",
        uses: "Nylon production, adhesives, paint remover",
        packaging: "150kg drums, IBC tanks",
      },
      {
        name: "Dimethyl Formamide (DMF)",
        description: "Polar aprotic solvent for chemical reactions",
        uses: "Pharmaceuticals, plastics, fibers, electronics",
        packaging: "180kg drums, IBC tanks",
      },
    ],
  },
  {
    name: "Pharmaceuticals & Dyestuff Intermediates",
    icon: "💊",
    products: [
      {
        name: "2,4 DNCB (Dinitrochlorobenzene)",
        description: "Intermediate for dyes and pharmaceuticals",
        uses: "Dye manufacturing, sulfur dye production",
        packaging: "25kg bags, 50kg drums",
      },
      {
        name: "H Acid",
        description: "Dyestuff intermediate for azo dyes",
        uses: "Reactive dyes, acid dyes, direct dyes",
        packaging: "25kg bags",
      },
      {
        name: "3,4 DCA (Dichloroaniline)",
        description: "Aromatic amine intermediate",
        uses: "Herbicides, dyes, pharmaceuticals",
        packaging: "25kg bags, 50kg drums",
      },
      {
        name: "ONCB (Ortho Nitrochlorobenzene)",
        description: "Nitro aromatic intermediate",
        uses: "Dye intermediate, agrochemical production",
        packaging: "200kg drums",
      },
      {
        name: "Ortho Anisidine",
        description: "Aromatic amine for pharmaceuticals",
        uses: "Dyes, pharmaceuticals, agrochemicals",
        packaging: "25kg drums, 200kg drums",
      },
      {
        name: "Zinc Chloride",
        description: "Inorganic salt catalyst and flux",
        uses: "Galvanizing, battery electrolyte, chemical catalyst",
        packaging: "25kg bags, 50kg drums",
      },
    ],
  },
  {
    name: "Agrochemical Intermediates",
    icon: "🌾",
    products: [
      {
        name: "DAP (Diammonium Phosphate)",
        description: "High phosphorus fertilizer",
        uses: "Agricultural fertilizer, fire retardant",
        packaging: "50kg bags, bulk bags",
      },
      {
        name: "Dimethylamine",
        description: "Aliphatic amine for agrochemical synthesis",
        uses: "Herbicides, fungicides, pharmaceuticals",
        packaging: "150kg drums, IBC tanks",
      },
      {
        name: "Magnesium Sulfate",
        description: "Magnesium salt fertilizer and supplement",
        uses: "Fertilizer, animal feed, pharmaceutical grade",
        packaging: "25kg bags, 50kg bags",
      },
      {
        name: "NBPT (N-(n-butyl) thiophosphoric triamide)",
        description: "Urease inhibitor for fertilizers",
        uses: "Urea fertilizer efficiency enhancer",
        packaging: "25kg drums",
      },
      {
        name: "Sulphur Bentonite",
        description: "Sulphur fertilizer with bentonite carrier",
        uses: "Soil amendment, sulfur deficiency correction",
        packaging: "50kg bags",
      },
    ],
  },
  {
    name: "Cosmetics & Home Care",
    icon: "✨",
    products: [
      {
        name: "Glycerine",
        description: "Humectant and moisturizer for personal care",
        uses: "Skin care, soap, toothpaste, pharmaceuticals",
        packaging: "25kg drums, 200kg drums, IBC tanks",
      },
      {
        name: "Zinc Oxide",
        description: "White pigment and UV protector",
        uses: "Sunscreen, cosmetics, ointments, rubber",
        packaging: "25kg bags",
      },
      {
        name: "White Oil",
        description: "Highly refined mineral oil",
        uses: "Cosmetics, pharmaceuticals, food grade applications",
        packaging: "15kg, 50kg, 200kg drums",
      },
      {
        name: "SLES (Sodium Lauryl Ether Sulfate)",
        description: "Anionic surfactant and foaming agent",
        uses: "Shampoos, body wash, detergents, cleaning products",
        packaging: "200kg drums, IBC tanks",
      },
      {
        name: "LABSA (Linear Alkyl Benzene Sulphonic Acid)",
        description: "Anionic surfactant for detergents",
        uses: "Laundry detergents, dishwashing liquids, industrial cleaners",
        packaging: "200kg drums, IBC tanks",
      },
      {
        name: "Sodium Silicate",
        description: "Alkaline solution for detergents and adhesives",
        uses: "Detergents, adhesives, water treatment, cement",
        packaging: "200kg drums, IBC tanks",
      },
    ],
  },
  {
    name: "Food Industry Chemicals",
    icon: "🍽️",
    products: [
      {
        name: "Citric Acid",
        description: "Natural acidulant and preservative",
        uses: "Beverages, food preservation, pH adjustment, confectionery",
        packaging: "25kg bags",
      },
      {
        name: "Liquid Caramel",
        description: "Natural food coloring and flavoring",
        uses: "Beverages, bakery, sauces, confectionery",
        packaging: "25kg, 200kg drums",
      },
      {
        name: "TBHQ (Tertiary Butylhydroquinone)",
        description: "Antioxidant preservative for oils and fats",
        uses: "Edible oils, snack foods, biodiesel",
        packaging: "25kg drums",
      },
      {
        name: "BHT (Butylated Hydroxytoluene)",
        description: "Antioxidant food preservative",
        uses: "Oils, fats, cereals, packaging materials",
        packaging: "25kg drums",
      },
      {
        name: "Boric Acid",
        description: "Mild antiseptic and preservative",
        uses: "Food preservation, eye wash, antiseptic",
        packaging: "25kg bags",
      },
      {
        name: "Sodium Nitrite",
        description: "Food preservative and color fixative",
        uses: "Meat curing, fish preservation, color retention",
        packaging: "25kg bags",
      },
      {
        name: "Guar Gum",
        description: "Natural thickening and stabilizing agent",
        uses: "Ice cream, sauces, bakery, beverages",
        packaging: "25kg bags",
      },
    ],
  },
];
